import CommonModelDiffRunResult from "./CommonModelDiffRunResult";
import { CommonModelDiffRunExecution, ViewExecutionLogsHandler } from "./entities";
import { sortDiffRunsByStatus } from "./helpers";

interface CommonModelDiffRunResultsListProps {
  candidateTitle?: string;
  diffRuns: CommonModelDiffRunExecution[];
  integrationID: string;
  setCommonModelDiffRunExecutions: (diffRuns: CommonModelDiffRunExecution[]) => void;
  onViewExecutionLogs?: ViewExecutionLogsHandler;
}

const CommonModelDiffRunResultsList = ({
  candidateTitle = "Staged",
  diffRuns,
  integrationID,
  setCommonModelDiffRunExecutions,
  onViewExecutionLogs,
}: CommonModelDiffRunResultsListProps) => {
  const sortedDiffRuns = sortDiffRunsByStatus(diffRuns);

  return (
    <>
      {sortedDiffRuns.map((diffRun) => (
        <CommonModelDiffRunResult
          key={diffRun.id}
          candidateTitle={candidateTitle}
          diffRun={diffRun}
          integrationID={integrationID}
          setCommonModelDiffRunExecutions={setCommonModelDiffRunExecutions}
          commonModelDiffRunExecutions={sortedDiffRuns}
          onViewExecutionLogs={onViewExecutionLogs}
        />
      ))}
    </>
  );
};

export default CommonModelDiffRunResultsList;
